<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <div [hidden]="isCreate || isEdit">
      <div class="header-container">
        <h2>Product Variant</h2>
        <div class="search-container">
          <input
            type="text"
            [formControl]="searchInput"
            placeholder="Search..."
            (input)="applyFilter()"
            class="form-control"
          />
          <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
        </div>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="add()">Add Product Variant</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
              paginatorRef.pageSize) + (i + 1) }}</td>
          </ng-container>

          <ng-container matColumnDef="variant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Variant </th>
            <td mat-cell *matCellDef="let element">{{element.variant}}</td>
          </ng-container>
          <ng-container matColumnDef="variant_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Variant Code </th>
            <td mat-cell *matCellDef="let element">{{element.variant_code?element.variant_code:'NA'}}</td>
          </ng-container>

          <ng-container matColumnDef="product_category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Category </th>
            <td mat-cell *matCellDef="let element">{{element?.product_category?.product_category}}</td>
          </ng-container>

          <ng-container matColumnDef="product_model">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Model </th>
            <td mat-cell *matCellDef="let element">{{element?.product_model?.model}}</td>
          </ng-container>

          <ng-container matColumnDef="product_color">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Color</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.product_color && element.product_color.length > 0">
                <span *ngFor="let color of element.product_color; let last = last">
                  {{ color.color }}<span *ngIf="!last">, </span>
                </span>
              </ng-container>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img src="/assets/images/pen.png" class="edit-pen" title="Edit" (click)="editData(element)">
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="7">No data found!
            </td>
          </tr>
        </table>

        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <ng-container *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>Product Variant</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
        </div>
      </div>
      <form [formGroup]="productVariantForm">
        <div class="row">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Variant Name</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Variant Name" formControlName="variant"
                  maxlength="60" [ngClass]="{ 'is-invalid': submitted && f['variant'].errors }" [readonly]="isEdit"/>
                <div *ngIf="submitted && f['variant'].errors" class="invalid-feedback">
                  <div *ngIf="f['variant'].errors['required']">
                    Variant Name is required
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Category</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <ng-container *ngIf="isCreate">
                <select name="" class="form-select" formControlName="category" (change)="getModel()"
                  [ngClass]="{ 'is-invalid': submitted && f['category'].errors }">
                  <option value="" disabled selected>--Select Category--</option>
                  <option [value]="data.id" *ngFor="let data of categoryList">{{data.product_category}}</option>
                </select>
              </ng-container>
              <ng-container *ngIf="isEdit">
                <input type="text" class="form-control" placeholder="category" formControlName="category" maxlength="60"
                  [ngClass]="{ 'is-invalid': submitted && f['model'].errors }" readonly/>
                </ng-container>
                <div *ngIf="submitted && f['category'].errors" class="invalid-feedback">
                  <div *ngIf="f['category'].errors['required']">Category is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Model</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <ng-container *ngIf="isCreate">
                <select name="" class="form-select" formControlName="model"
                  [ngClass]="{ 'is-invalid': submitted && f['model'].errors }">
                  <option value="" disabled selected>--Select Model--</option>
                  <option [value]="data.id" *ngFor="let data of modelList">{{data.model}}</option>
                </select>
              </ng-container>
              <ng-container *ngIf="isEdit">
                <input type="text" class="form-control" placeholder="model" formControlName="model" maxlength="60"
                  [ngClass]="{ 'is-invalid': submitted && f['model'].errors }" readonly/>
              </ng-container>
                <div *ngIf="submitted && f['model'].errors" class="invalid-feedback">
                  <div *ngIf="f['model'].errors['required']">Model is required</div>
                </div>
              </div>
            </div>


            <!-- <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Color</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="color"
                  [ngClass]="{ 'is-invalid': submitted && f['color'].errors }">
                  <option value="" disabled selected>--Select Color--</option>
                  <option [value]="data.id" *ngFor="let data of colorList">{{data.color}}</option>
                </select>
                <div *ngIf="submitted && f['color'].errors" class="invalid-feedback">
                  <div *ngIf="f['color'].errors['required']">Category is required</div>
                </div>
              </div>
            </div> -->
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Color</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <ng-container *ngIf="isCreate">
                <ng-multiselect-dropdown [placeholder]="'Select Product Color'" formControlName="color"
                  class="form-control" [settings]="dropdownSettingsColors" [data]="colorList"
                  [ngClass]="{ 'is-invalid': submitted && f['color'].errors }">
                </ng-multiselect-dropdown>
              </ng-container>
              <ng-container *ngIf="isEdit">
                <input type="text" class="form-control" placeholder="color" formControlName="color" maxlength="60"
                  [ngClass]="{ 'is-invalid': submitted && f['color'].errors }" readonly/>
              </ng-container>
                <div *ngIf="submitted && f['color'].errors" class="invalid-feedback">
                  <div *ngIf="f['color'].errors['required']">Product Color is required</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Status</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="status"
                  [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                  <option value="" disabled selected>--Select Status--</option>
                  <option value="1">Active</option>
                  <option value="0">In-Active</option>
                </select>
                <div *ngIf="submitted && f['status'].errors" class="invalid-feedback">
                  <div *ngIf="f['status'].errors['required']">Status is required</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Variant Code</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Variant Code" formControlName="variantCode"
                  maxlength="60" [ngClass]="{ 'is-invalid': submitted && f['variantCode'].errors }" [readonly]="isEdit"/>
                <div *ngIf="submitted && f['variantCode'].errors" class="invalid-feedback">
                  <div *ngIf="f['variantCode'].errors['required']">
                    Variant Code is required
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-lg-12 mt-5">
            <div class="text-right-right">
              <button *ngIf="isCreate" mat-raised-button class="clear-button" (click)="clearForm()">Clear</button>
              <button *ngIf="isCreate" class="create-button ml-2" mat-raised-button (click)="create()">Create</button>
              <button *ngIf="isEdit" class="create-button ml-2" mat-raised-button (click)="update()">Update</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>
